'use strict';
var base = require('base/product/base');
var searchBase = require('base/search/search');
var searchExport = {};
var sortingRule;
// 78079
// 165827
var userAuth = $('.search-results').data('iscustomerauthenticated');
[searchBase].forEach(function (library) {
    Object.keys(library).forEach(function (item) {
        if (typeof library[item] === 'object') {
            searchExport[item] = $.extend({}, base[item], library[item]);
        } else {
            searchExport[item] = library[item];
        }
    });
});

searchExport.clickToPdp = function () {
    $('.container').off('click', 'form button.product-tile-btn');
    $('.container').on('click', 'form button.product-tile-btn', function (e) {
        e.preventDefault();
        window.location.href = $(this).attr('formaction');
    });
};

function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.refinements');
}
// 413229
function handleSort() {
    sortingRule = sessionStorage.getItem('selectedOptionDataId');
    if (sortingRule) {
        try {
            $('.custom-select.custom-sort.c-filter-select option').each(function () {
                if (sortingRule) {
                    var hasClassMatch = $(this).hasClass(sortingRule);
                    var dataAttrMatch = $(this).data('id') === sortingRule;
                    var isAlreadySelected = $(this).is(':selected');
                    if ((hasClassMatch || dataAttrMatch) && !isAlreadySelected) {
                        $(this).attr('selected', 'selected');
                    }
                }
            });
        } catch (e) {
            console.error('Error parsing session data:', e);
        }
    }
}
// 413229

// 26723 Change Start
/* Parse the response and replace only selected classes */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar',
        '.tile-count',
        '#filterSubCategory'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
    $('.lre-attributes').each(function (key, value) {
        var filterId = '#' + value.id;
        if (value.id !== 'filterproducttype') {
            updateDom($results, filterId);
        }
    });
    handleSort();
}
function parseResponse(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar',
        '.tile-count'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });
    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
    handleSort();
}
// Reset all the filters when there are no filters applied
function resetFilters(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar',
        '.tile-count',
        '#filterSubCategory'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
    /* Story ID - 26254 Change Start  Refresh the refinements when all the filters are cleared */
    $('.lre-attributes').each(function (key, value) {
        var filterId = '#' + value.id;
        updateDom($results, filterId);
    });
    handleSort();
    /* Story ID - 26254 Change End*/
}
// 26723 Change End
// 86401
function updateFromLocalStorage() {
    var datapiwl = localStorage.getItem('prodsinwishlist');
    if (datapiwl !== '') {
        datapiwl = datapiwl ? datapiwl.split(',') : [];
        for (var i = 0; i < datapiwl.length; i++) {
            $('[data-pid=' + datapiwl[i] + '] .wishlistTile').removeClass("addToWishlist").addClass("removeFromWishlist wishlist-product-isadded");
        }
    }
}

searchExport.initialize = function () {
    function getDocHeight() {
        var D = document;
        return Math.max(
            D.body.scrollHeight, D.documentElement.scrollHeight,
            D.body.offsetHeight, D.documentElement.offsetHeight,
            D.body.clientHeight, D.documentElement.clientHeight
        );
    }

    $(document).ready(function () {
        // 59035 Mobile Filter Start
        var mobileFilterFlag = false;
        function setApplyBtnDisabled() {
            if (mobileFilterFlag === false) {
                $('#applyFiltersMobile').attr('disabled', true);
            } else {
                $('#applyFiltersMobile').attr('disabled', false);
            }
        }
        handleSort();
        // 59035 Mobile Filter Start
        var lastScrollTop = 0;
        function scrollFunction() {
            var st = $(this).scrollTop();
            if (st > lastScrollTop) {
                var footerHeight = $('#footercontent').outerHeight();
                if ($(window).scrollTop() + $(window).height() > getDocHeight() - footerHeight) {
                    $(window).unbind("scroll");
                    var showMoreUrl = $('div.infinite-scroll').data('url');
                    var currentPage = $('div.infinite-scroll').data('currentpage');
                    var maxPage = $('div.infinite-scroll').data('maxpage');
                    if (currentPage < maxPage) {
                        $('.inline-loader').show();
                        $('.inline-loader span').focus();
                        $.ajax({
                            url: showMoreUrl,
                            data: { selectedUrl: showMoreUrl },
                            method: 'GET',
                            success: function (response) {
                                $('.grid-footer').replaceWith(response);
                                updateSortOptions(response);
                                $('.inline-loader').hide();
                                // 90066
                                if (userAuth) {
                                    updateFromLocalStorage();
                                }
                                $(window).scroll(scrollFunction);
                            },
                            error: function () {
                                $('.inline-loader').hide();
                            }
                        });
                    }
                }
            }
            lastScrollTop = st;
            // 22196 Start
            $(window).scroll(function () {
                if ($(window).scrollTop() > 0) {
                    $('body').addClass('nav-sticky');
                    // $('.header-top-banner').slideUp(); Story#60324
                    $('.back-to-top').fadeIn();
                } else {
                    $('body').removeClass('nav-sticky');
                    // $('.header-top-banner').slideDown(); Story#60324
                    $('.back-to-top').fadeOut();
                }
            });
            // 22196 End
        }
        var frmlen = document.forms.length;
        for (var i = 0; i < frmlen; i++) {
            document.forms[i].reset();
        }
        $('.product-tiles__list').slick({
            dots: false,
            arrows: true,
            slidesToShow: 3,
            infinite: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        arrows: true,
                        dots: true,
                        infinite: true
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        dots: true,
                        arrows: false,
                        slidesToShow: 2,
                        infinite: true
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        dots: true,
                        arrows: false,
                        slidesToShow: 1,
                        infinite: true
                    }
                }
            ]
        });
        $(document).on('afterChange', '.product-tiles__list', function (slick) {
            // 25291 start
            setTimeout(() => {
                $(this).find('.slick-current').find('a').eq(0)
                    .focus();
            }, 300);
            // 25291 end
        });

        /** *************************** Filter Section ****************************** **/
        var list = [];
        var filterStatus = false;
        // 26723 Change End
        /* On click of CLOSE BUTTON on the selected filter */
        $(document).on('click', '.c-filter__unselect', function () {
            $.spinner().start();
            $(this).parents('.c-filter__selected-item').remove();
            $("#" + $(this).attr('data-targeinput')).prop('checked', false);
            $("#" + $(this).attr('data-targeinput')).trigger('change');
            if (list === undefined || list.length === 0) {
                var url = $('.c-filter__clear button').attr('data-href');
                var hasQuery = url.indexOf('?') !== -1;
                url = url + (hasQuery ? '&' : '?') + 'reset=true';
                $.ajax({
                    url: url,
                    data: {
                        page: $('.grid-footer').data('page-number'),
                        selectedUrl: $(this).data('href')
                    },
                    method: 'GET',
                    success: function (response) {
                        // 26723 Change Start
                        resetFilters(response); // Reset All the filters if there is no filter selection
                        // 26723 Change End
                        $('.c-filter__options-list input:checked').trigger('change');
                        // 90066
                        if (userAuth) {
                            updateFromLocalStorage();
                        }
                        $.spinner().stop();
                        $(window).scroll(scrollFunction);
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            } else {
                // 24623 - Change Start - Setting timer to display the spinner during the filter removal
                setTimeout(function () {
                    $.spinner().stop();
                }, 5000);
                // 24623 - Change End
            }
        });

        $(document).on('keyup', '.c-filter__unselect', function (e) {
            e.preventDefault();
            if (e.keyCode === 13) {
                $(this).parents('.c-filter__selected-item').remove();
                $("#" + $(this).attr('data-targeinput')).prop('checked', false);
                $("#" + $(this).attr('data-targeinput')).trigger('change');
            }
        });
        /* On click of CLEAR ALL FILTERS */
        $(document).on('click', '.c-filter__clear button', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $.spinner().start();
            $(this).parent().prev('.c-filter__selected-list').find('.c-filter__selected-item')
                .remove();
            $('.c-filter__selected').hide();
            $('.c-filter__item button').removeClass('selected');
            $('.c-filter__options-list input').prop('checked', false); // 90066 .trigger('change');
            var url = $(this).data('href');
            var hasQuery = url.indexOf('?') !== -1;
            url = url + (hasQuery ? '&' : '?') + 'reset=true';
            $.ajax({
                url: url,
                data: {
                    page: $('.grid-footer').data('page-number'),
                    selectedUrl: $(this).data('href')
                },
                method: 'GET',
                success: function (response) {
                    // 26723 - Change Start
                    resetFilters(response); // Reset All the filters if there is no filter selection
                    // 26723 Change End
                    $('.c-filter__options-list input:checked').trigger('change');
                    $('.c-filter__content').collapse('hide');
                    $('.tile-count span:visible').focus();
                    // 90066
                    if (userAuth) {
                        updateFromLocalStorage();
                    }
                    $.spinner().stop();
                    $(window).scroll(scrollFunction);
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
        $(document).on('click', '.c-filter__hardclear button', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $.spinner().start();
            $(this).parent().prev('.c-filter__selected-list').find('.c-filter__selected-item')
                .remove();
            $('.c-filter__selected').hide();
            $('.c-filter__item button').removeClass('selected');
            $('.c-filter__options-list input').prop('checked', false); // 90066 .trigger('change');
            var url = $(this).data('href');
            var hasQuery = url.indexOf('?') !== -1;
            url = url + (hasQuery ? '&' : '?') + 'hardreset=true';
            $.ajax({
                url: url,
                data: {
                    page: $('.grid-footer').data('page-number'),
                    selectedUrl: $(this).data('href')
                },
                method: 'GET',
                success: function (response) {
                    window.location.reload();
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
        /* Disable the APPLY button if there is no selected filter */
        /* Disables only after the Apply button is clicked atleast once */
        function disableApplyBtn() {
            if ($('.c-filter__selected-list .c-filter__selected-item').length === 0) {
                if (filterStatus === true) {
                    $('.apply').prop('disabled', false);
                } else {
                    $('.apply').prop('disabled', true);
                }
            } else {
                $('.apply').prop('disabled', false);
            }
        }
        // 378120
        function escapeHtml(text) {
            return $('<div>').text(text).html();
        }
        function populateFilters() {
            $('.c-filter__selected-list').html('');
            list = [];
            $('.c-filter__options-list input').each(function () {
                if ($(this).is(':checked') === true) {
                    list.push($(this).attr('data-href'));
                    $('#' + $(this).data('parentfilter')).addClass('selected');
                    $('.c-filter__selected').show();
                    var applabel = escapeHtml($(this).next('label').text());
                    var appid = $(this).attr('id');
                    $('.c-filter__selected-list').append('<li class="c-filter__selected-item"><div class="c-filter__selected-button position-relative" tabindex="0" aria-label="' + applabel + '">' + applabel + '<button type="button" class="c-filter__unselect" title="Remove Filter" data-targeInput="' + appid + '">Remove Filter</button></div></li>');
                }
            });

            // 59035
            var contentId;
            var contentLength;
            var contentSelector;
            $('.c-filter__content').each(function () {
                contentId = $(this).attr('id');
                contentSelector = '#' + contentId + 'ButtonMobile span';
                contentLength = $(this).find('input:checked').length;
                if (contentLength > 0) {
                    if (contentLength === 1) {
                        $(contentSelector).removeAttr('aria-hidden').attr('aria-label', contentLength + ' Filter Selected').html(contentLength);
                    } else {
                        $(contentSelector).removeAttr('aria-hidden').attr('aria-label', contentLength + ' Filters Selected').html(contentLength);
                    }
                } else {
                    $(contentSelector).attr({ 'aria-hidden': true }).removeAttr('aria-label').html('');
                }
            });
            // 59035
            // 64851
            if ($('#filterCategoryButton').is(':visible') || $('#filterCategoryButtonMobile').is(':visible')) {
                if ($('#filterCategory').find('input:checked').length === 0) {
                    /* Story ID - 26254 Change Start  Remove Sub Category selection when the category is cleared */
                    $('.sub-categories-options-list input:checked').prop('checked', false).trigger('change');
                    /* Story ID - 26254 Change End */
                    $('.sub-category-box').hide();
                }
            }
            /* Story ID - 25266 Change Start */
            /* Hiding the Sub Category Box when navigated to PLP from Navigation Menu of any Hidden Category */
            /* Hides the sub category filter when the category box is not visible AND sub category box is empty */
            if (!($('#filterCategoryButton').is(':visible')) && !($('#filterCategoryButtonMobile').is(':visible')) && $('.sub-categories-options-list').find('.c-filter__option').length === 0) {
                // $('#filterSubCategory').hide();
                $('.sub-category-box').hide();
            }
            /* Story ID - 25266 Change Start */
            disableApplyBtn();
        }
        populateFilters();
        function getCategoryParameterForUrl() {
            var categoryParameterForUrl = '';
            var selectedCategory = $('.c-filter__items').attr('data-selectedcategory');
            if ($('.sub-categories-options-list').find('input:checked').length !== 0) {
                selectedCategory = $('.sub-categories-options-list').find('input:checked').attr('data-refinement-value');
            } else if ($('.categories-options-list').find('input:checked').length !== 0) {
                selectedCategory = $('.categories-options-list').find('input:checked').attr('data-refinement-value');
            }
            // Assign only if the category is not null
            if (selectedCategory !== 'null') {
                categoryParameterForUrl = 'cgid=' + selectedCategory;
            }
            return categoryParameterForUrl;
        }
        function getAttributeParametersForUrl() {
            var attributeParametersForUrl = '';
            var filterid;
            var prefn = 'prefn';
            var prefv = 'prefv';
            var selectedLreAttributesCount = 1;
            $('.lre-attributes').each(function (key, value) {
                var $filter = $('#' + value.id);
                if ($filter.find('input:checked').length > 0) {
                    filterid = $filter.find('input:checked').attr('data-refinement-id');
                    attributeParametersForUrl += '&' + prefn + selectedLreAttributesCount + '=' + filterid;
                    attributeParametersForUrl += '&' + prefv + selectedLreAttributesCount + '=';
                    $filter.find('input:checked').each(function (index, element) {
                        if (index === 0) {
                            attributeParametersForUrl += $(this).attr('data-refinement-value');
                        } else {
                            attributeParametersForUrl += '|' + $(this).attr('data-refinement-value');
                        }
                    });
                    selectedLreAttributesCount += 1;
                }
            });
            return attributeParametersForUrl;
        }
        /*
         * Function to include the search keywords into the url.
         * This function gets called when Apply button is clicked and checked it there are any searched words.
         * If yes, it will append in the URL. If no search words, it will return null.
         */
        function getSearchParametersForUrl() {
            var searchKeywords = $('#product-search-results').attr('data-searchkeywords');
            var searchParameterForUrl = '';
            if (searchKeywords !== 'null') {
                searchParameterForUrl = '&q=' + searchKeywords;
            }
            return searchParameterForUrl;
        }
        // 26723 - Change Start
        // Clear the selection of the box when there are no input fields selected in that filter is not selected
        function clearSelectedFilters() {
            $('.c-filter__items .c-filter__content').each(function () {
                var siblingFilters = $(this).find('.c-filter__options-list input').attr('data-parentfilter');
                if ($('input[data-parentfilter="' + siblingFilters + '"]:checked').length === 0) {
                    $("#" + siblingFilters).removeClass('selected');
                }

                if ($('.c-filter__selected-list').find('li').length === 0) {
                    $('.c-filter__selected').hide();
                }
            });
        }
        // 26723 Change End
        // 24623 - Change Start - Commenting this code related to apply button
        /* On click of APPLY button */
        /* $(document).on('click', '.apply', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $.spinner().start();
            var url = $('.c-filter__items').attr('data-url');
            var newUrl = url + '?';
            var categoryParameterForUrl = getCategoryParameterForUrl();
            var attributeParametersForUrl = getAttributeParametersForUrl();
            // Append the search word as parameters in the URL.
            var searchParametersForUrl = getSearchParametersForUrl();
            if (searchParametersForUrl !== '' && categoryParameterForUrl === '') {
                newUrl = newUrl + searchParametersForUrl + attributeParametersForUrl;
            } else {
                newUrl = newUrl + categoryParameterForUrl + attributeParametersForUrl;
            }
            $.ajax({
                url: newUrl,
                data: {
                    page: $('.grid-footer').data('page-number'),
                    selectedUrl: $(this).data('href')
                },
                method: 'GET',
                success: function (response) {
                    // 26723 Change Start Filters Fix- Reset the filters only if there are product tiles in the response
                    var $results = $(response);
                    var tileCount = $results.find('.tile-count').length;
                    if (tileCount > 0) {
                        parseResults(response);
                    } else {
                        parseResponse(response);
                    }
                    // 26723 Change End
                    hideEmptyFilters(); // Hide the empty filter boxes if there don't have any values.
                    populateFilters();
                    clearSelectedFilters(); // Clear the filter box selextion, if no input values are selected in that filter
                    filterStatus = true;
                    $('.c-filter__content').collapse('hide');
                    $('.tile-count span:visible').focus();
                    $.spinner().stop();
                    $('.common-product-grid .prod-description, .common-product-grid .tile-date, .common-product-grid .price .value').attr('tabindex', '0');
                    $(window).scroll(scrollFunction);
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }); */
        // 24623 - Change End
        $(document).on('change', '.c-filter__options-list input', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $.spinner().start();
            populateFilters();
            mobileFilterFlag = true;
            setApplyBtnDisabled();
            var siblingFilters = $(this).attr('data-parentfilter');

            if ($('input[data-parentfilter="' + siblingFilters + '"]:checked').length === 0) {
                $("#" + siblingFilters).removeClass('selected');
            }

            if ($('.c-filter__selected-list').find('li').length === 0) {
                $('.c-filter__selected').hide();
            }
            // 24623 - Change Start - On change of filter options, the filters should get automatically applied based on selection
            var url = $('.c-filter__items').attr('data-url');
            var newUrl = url + '?';
            var categoryParameterForUrl = getCategoryParameterForUrl();
            var attributeParametersForUrl = getAttributeParametersForUrl();
            // Append the search word as parameters in the URL.
            var searchParametersForUrl = getSearchParametersForUrl();
            if (searchParametersForUrl !== '' && categoryParameterForUrl === '') {
                newUrl = newUrl + searchParametersForUrl + attributeParametersForUrl;
            } else {
                newUrl = newUrl + categoryParameterForUrl + attributeParametersForUrl;
            }
            $.ajax({
                url: newUrl,
                data: {
                    page: $('.grid-footer').data('page-number'),
                    selectedUrl: $(this).data('href')
                },
                method: 'GET',
                success: function (response) {
                    parseResponse(response);
                    populateFilters();
                    clearSelectedFilters(); // Clear the filter box selection, if no input values are selected in that filter
                    filterStatus = true;
                    $('.tile-count span:visible').focus();
                    // 90066
                    if (userAuth) {
                        updateFromLocalStorage();
                    }
                    $.spinner().stop();
                    $(window).scroll(scrollFunction);
                },
                error: function () {
                    $.spinner().stop();
                }
            });
            // 24623 - Change End
        });
        /*
         * 24623 - On click of category filter, the subcategory box should load
         */
        function showSubCategoryFilter(response) {
            var $results = $(response);
            var specialHandlers = {
                '.refinements': handleRefinements
            };

            // Update DOM elements that do not require special handling
            [
                '.grid-header',
                '.header-bar',
                '.header.page-title',
                '.product-grid',
                '.show-more',
                '.filter-bar',
                '.tile-count',
                '#filterSubCategory'
            ].forEach(function (selector) {
                updateDom($results, selector);
            });
            Object.keys(specialHandlers).forEach(function (selector) {
                specialHandlers[selector]($results);
            });
        }
        // 24623 - Change End
        /* Ajax call to populate the Sub Category box on selection of category */
        $(document).on('change', '.categories-options-list input', function (e) {
            if ($('body').find('#filterCategoryButton').length !== 0 || $('body').find('#filterCategoryButtonMobile').length !== 0) {
                if ($('.categories-options-list').find('input:checked').length !== 0) {
                    $('.sub-category-box').show();
                    var url = $('.c-filter__items').attr('data-url');
                    var newUrl = url + '?';
                    // 26723 change start - Dynamically construct URL based on the filters selected.
                    // Here only the Category is fetched because this is on Category change
                    var selectedCategory;
                    if ($('.categories-options-list').find('input:checked').length !== 0) {
                        selectedCategory = $('.categories-options-list').find('input:checked').attr('data-refinement-value');
                    }
                    var attributeParametersForUrl = getAttributeParametersForUrl();
                    newUrl = newUrl + 'cgid=' + selectedCategory + attributeParametersForUrl;
                    // 26723 Change End
                    $.spinner().start();
                    $.ajax({
                        url: newUrl,
                        success: function (response) {
                            // 24623 - Change Start
                            var $results = $(response);
                            var tileCount = $results.find('.tile-count').length;
                            if (tileCount > 0) {
                                parseResults(response); // if tile count is greater than 0, then change the filters.
                            } else {
                                showSubCategoryFilter(response); // if no products present, only load the sub category box and not change the rest filters
                            }
                            // 24623 - Change End
                            populateFilters();
                            // 90066
                            if (userAuth) {
                                updateFromLocalStorage();
                            }
                            $.spinner().stop();
                        },
                        error: function () {
                            $.spinner().stop();
                        }
                    });
                } else {
                    $('.sub-category-box').hide();
                    $('.sub-categories-options-list').find('input:checked').prop('checked', false).trigger('change');
                    $('.sub-category-box').next('.c-filter__content').html('');
                }
            }
        });
        /** *************************** Filter Section ****************************** **/
        // 64851
        // 59041 Mobile Sort Start
        if ($('body').find('#customSorting select').length !== 0) {
            var native = $('#customSorting select');
            var sortNav = $('.mobile-sort .mobile-sort__body .nav');
            var optionText;
            var optionId;

            // get and create custom link options
            native.children('option').each(function () {
                optionText = $(this).text();
                optionId = $(this).data('id');
                // Identify the "sort by" option and ignore"
                if (optionText.toLowerCase().replace(/\s/g, "") !== "sortby") {
                   // #15-378120
                    var isSelected = (sortingRule && sortingRule === optionId) || $(this).is(':selected');
                    var $link = $('<a>', {
                        class: 'nav-link custom-sort__link' + (isSelected ? ' active' : ''),
                        href: '#',
                        'data-id': optionId,
                        text: optionText.trim()
                    });

                    if (isSelected) {
                        $link.attr('aria-selected', 'true');
                    }

                    sortNav.append($link);
                }
            });
        }

        // Open custom mobile sort by click on sort button
        $('.c-btn__sort').on('click', function (e) {
            e.preventDefault();
            $('body').addClass('hide-sroller');
            $(this).addClass('active').attr('aria-expanded', true);
            $('#mobileSort').addClass('active');
            $('.custom-sort__link.active').focus();
        });

        // Close the sort by click on close button, sort backdrop, and sort item
        $('.btn-sort__close, .mobile-sort__backdrop').on('click', function (e) {
            e.preventDefault();
            $('body').removeClass('hide-sroller');
            $('.c-btn__sort').removeClass('active').attr('aria-expanded', false).focus();
            $('#mobileSort').removeClass('active');
        });
        $('.custom-sort__link').on('click', function (e) {
            e.preventDefault();
            $('body').removeClass('hide-sroller');
            $('.c-btn__sort').removeClass('active').attr('aria-expanded', false).focus();
            $('#mobileSort').removeClass('active');
        });

        // Loop sort
        $('.loop-sort').on('focus', function () {
            $('.btn-sort__close').focus();
        });
        // Update select value on click
        $('.custom-sort__link').on('click', function () {
            var thisLink = $(this);
            var thisId = $(this).data('id');
            $('.custom-sort__link').not(thisLink).removeAttr('aria-selected').removeClass('active');
            $(this).addClass('active').attr('aria-selected', true);
            $('#customSorting select option').prop('selected', false).removeAttr('selected');
            $('#customSorting select option[data-id="' + thisId + '"]').prop('selected', true);
            $('#customSorting select').trigger('change');
        });

        // 59041 Mobile Sort Ends

        // 59035 Mobile Filter Start
        // Open custom mobile Filters by click on sort button
        $('.c-btn__filter').on('click', function (e) {
            e.preventDefault();
            $('body').addClass('hide-sroller');
            $(this).addClass('active').attr('aria-expanded', true);
            $('#mobileFilter').addClass('active');
            $('.c-filter__items').find('.btn-filter__mobile')[0].focus();
            mobileFilterFlag = false;
            setApplyBtnDisabled();
            $('#mobileFilter .c-filter__items .c-filter__content').each(function () {
                if ($(this).html().trim().length === 0) {
                    $(this).html($(this).html().trim());
                    $(this).prev('.btn-filter__mobile').hide();
                    $(this).prev('.sub-category-box').hide();
                }
            });
        });

        // Close the filter by click on close button an apply filter button
        $('.btn-filter__close, #applyFiltersMobile').on('click', function (e) {
            e.preventDefault();
            $('body').removeClass('hide-sroller');
            $('.c-filter__content').collapse('hide');
            $('.c-btn__filter').removeClass('active').attr('aria-expanded', false).focus();
            $('#mobileFilter').removeClass('active');
            $(".c-filter__selected__mobile").html('');
            $(".c-filter__selected .c-filter__selected-list").clone().appendTo(".c-filter__selected__mobile");
            mobileFilterFlag = false;
            setApplyBtnDisabled();
        });

        // Clear filters
        $('#clearFiltersMobile').on('click', function () {
            $('.c-filter__clear button').trigger('click');
            setTimeout(function () {
                $('body').removeClass('hide-sroller');
                $('.c-btn__filter').removeClass('active').attr('aria-expanded', false).focus();
                $('#mobileFilter').removeClass('active');
            }, 1500);
            mobileFilterFlag = false;
            // 90066
            populateFilters();
            setApplyBtnDisabled();
        });
        // Loop sort
        $('.loop-filter').on('focus', function () {
            $('.btn-filter__close').focus();
        });
        // 59035 Mobile Filter Ends
        // 90066
        $(window).scroll(scrollFunction);
    });

    $(window).on('load', function () {
        $('.slick-arrow').each(function () {
            $(this).attr('title', $(this).attr('aria-label'));
        });
    });
    // 86401
};

searchExport.sort = function () {
    // Handle sort order menu selection
    $('.container').on('change', '[name=sort-order]', function (e) {
        e.preventDefault();
        var selectedDataId = $(this).find('option:selected').data('id');
        // Save it to sessionStorage
        if (selectedDataId !== undefined) {
            sessionStorage.setItem('selectedOptionDataId', selectedDataId);
        }
        $.spinner().start();
        $(this).trigger('search:sort', this.value);
        $.ajax({
            url: this.value,
            data: { selectedUrl: this.value },
            method: 'GET',
            success: function (response) {
                $('.product-grid').empty().html(response);
                if (userAuth) {
                    updateFromLocalStorage();
                }
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
};

module.exports = searchExport;
